import { LangEnum } from '@utmb/types/enum/LangEnum';

export const formatDate = (locale: LangEnum, date: Date) =>
    new Intl.DateTimeFormat(locale, {
        month: 'short',
        day: 'numeric',
        year: 'numeric',
    } as Intl.DateTimeFormatOptions).format(date);

export const formatDateToApi = (date: Date) => new Intl.DateTimeFormat('fr-CA', { year: 'numeric', month: '2-digit', day: '2-digit' }).format(date);
